import { useEffect, useState, type MouseEventHandler } from "react";

export function useMobileNavigation() {
  const [mobileOpen, setMobileOpen] = useState(false);
  useEffect(() => {
    const wide = window.matchMedia("(min-width: 900px)");
    const closeOnWide = () => {
      if (wide.matches) setMobileOpen(false);
    };
    wide.addEventListener("change", closeOnWide);
    return () => wide.removeEventListener("change", closeOnWide);
  }, []);
  const closeMobile = () => setMobileOpen(false);
  const closeOnNavigation: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey ||
      event.currentTarget.target === "_blank" ||
      event.currentTarget.hasAttribute("download")
    )
      return;

    closeMobile();
  };

  return { mobileOpen, setMobileOpen, closeMobile, closeOnNavigation };
}
